<template>
    <div style="max-width: 1000px; margin: 0 auto;">
        <qrcode-stream style="border: 1px solid #c5c5c5; border-radius: 10px;" :camera="camera" @decode="onDecode" :track="paintOutline" @init="onInit"/>
        <div class="d-flex justify-content-center mt-4">
            <CustomSelect style="min-width: 300px;" v-model="camera" @change="saveCameraPreference" placeholder="Select" :options="getOptions">
            </CustomSelect>
        </div>
    </div>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from '@jyotirmay/vue-qrcode-reader-extended'
import { mapState } from 'vuex'
import CustomSelect from "./CustomSelect.vue";


export default {
    components: {
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture,
        CustomSelect
    },
    data () {
        return {
            accept: true,
            method: 'qr',
            activityDetails: {},
            camera: "rear",
            cameras:[],
            stream: null
        }
    },
    async mounted(){
        this.stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: true,
        })
        const devices = await navigator.mediaDevices.enumerateDevices()
        this.cameras = devices.filter((device) => ["videoinput"].includes(device.kind));
        const prefferedCamera = localStorage.getItem("preferredCamera")
        if(prefferedCamera){
            this.camera = prefferedCamera;
        }        
    },

    async destroyed(){
        await this.stopMediaStram();
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ]),
        getOptions(){
            let arr = []
            this.cameras.forEach((cam,i) =>{
                arr.push({
                    label: `camera ${i+1}`,
                    value: cam.deviceId
                })
            })
            arr.push({
                label: `Main Rear Camera`,
                value: "rear"
            })

            console.log(arr);
            

            return arr;
        }
    },
    methods: {
        saveCameraPreference(camera){
            localStorage.setItem("preferredCamera", camera);
        },
        async stopMediaStram(){
            if(this.stream){
                this.stream.getTracks().forEach(track => track.stop())
            }
        },
        onDecode: async function (decodedString) {
            this.$emit('onDecode', decodedString);
        },
        async onInit (promise) {
            try {
                await promise
            } catch (error) {
                console.error(error)
            }
        },
        paintOutline (detectedCodes, ctx) {
            for (const detectedCode of detectedCodes) {
                const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints
                ctx.strokeStyle = "red";
                ctx.beginPath();
                ctx.moveTo(firstPoint.x, firstPoint.y);
                for (const { x, y } of otherPoints) {
                ctx.lineTo(x, y);
                }
                ctx.lineTo(firstPoint.x, firstPoint.y);
                ctx.closePath();
                ctx.stroke();
            }
        },
        async switchCamera (deviceId) {
            this.error = false;
            this.camera = deviceId;
        },
    }
}
</script>